import { PrivacySettingKey } from './privacy.state';

const tag = '[Privacy]';

export class StorePrivacySetting {
  static readonly type = `${tag} store privacy setting`;
  constructor(
    public key: PrivacySettingKey,
    public value: string | boolean,
  ) {}
}
